import { useEffect, useState } from "react";

import { Button, Slider } from "@upstageai/ui";

import { Icon, Icons, IconSourceType } from "../../components/Icon";
import { MAX_ZOOM_RATIO, MIN_ZOOM_RATIO } from "../../constants/ImageScale";

export interface ImageZoomControlProps {
  imageScale: number;
  onClickZoomIn: () => void;
  onClickZoomOut: () => void;
  onImageHandler: (imageScale: number) => void;
}

export default function ImageZoomControl({
  imageScale,
  onClickZoomIn,
  onClickZoomOut,
  onImageHandler,
}: ImageZoomControlProps): JSX.Element {
  const [zoomSliderValue, setZoomSliderValue] = useState<number[]>([
    Math.log10(imageScale * 100) * 1000,
  ]);

  useEffect(() => {
    setZoomSliderValue([Math.log10(imageScale * 100) * 1000]);
  }, [imageScale]);

  const ZoomButton = ({
    onClick,
    icon,
  }: {
    onClick: () => void;
    icon: IconSourceType;
  }) => (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      className="hidden shrink-0 md:flex"
    >
      <Icon source={icon} />
    </Button>
  );

  return (
    <div className="flex h-full w-full items-center justify-center gap-3 sm:gap-0">
      {/* 축소 */}
      <ZoomButton onClick={onClickZoomOut} icon={Icons.ZoomOut} />

      {/* 줌 슬라이더 */}
      <div className="w-full items-center justify-center">
        <Slider
          value={zoomSliderValue}
          onValueChange={([value]) => {
            let nextValue = Math.pow(10, value / 1000) / 100;
            if (nextValue < MIN_ZOOM_RATIO) {
              nextValue = MIN_ZOOM_RATIO;
            }
            if (nextValue > MAX_ZOOM_RATIO) {
              nextValue = MAX_ZOOM_RATIO;
            }

            onImageHandler(nextValue);
          }}
          aria-label="Image zoom"
          max={Math.log10(MAX_ZOOM_RATIO * 100) * 1000}
          step={1}
        />
      </div>

      {/* 확대 */}
      <ZoomButton onClick={onClickZoomIn} icon={Icons.ZoomIn} />
    </div>
  );
}
